import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'ai-playground',
})
export default class AIPlayground extends Vue {

    // -------------------------------------------------
    // Properties

}
